import { ApiData, Entity, EntityId } from 'entities-next/common'

export type User = Entity & CommonUserData

export type CommonUserData = {
  readonly firstName: string
  readonly lastName: string
  readonly email: string
  readonly role: UserRole
  readonly status: UserStatus
  readonly position?: string
  readonly admin: boolean
  readonly highlighted: boolean
  readonly askForOnboarding: boolean
  readonly corporateId: EntityId
  readonly passwordResetToken?: string
}

export enum UserStatus {
  active = 'active',
  zombie = 'zombie',
  onHold = 'on-hold',
  churned = 'churned',
}

export enum UserRole {
  manager = 'manager',
  member = 'member',
  collaborator = 'collaborator',
}

export type ApiUser = User
export type ApiUserData = ApiData<ApiUser>

export const USER_CACHE_STORE_ID = 'users'
